import { render, staticRenderFns } from "./HazardList.vue?vue&type=template&id=c2a94494&"
import script from "./HazardList.vue?vue&type=script&lang=js&"
export * from "./HazardList.vue?vue&type=script&lang=js&"
import style0 from "./HazardList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports